import type { ReactNode } from 'react';
import { APP_NAME } from '../lib/appConfig';
import BrandBackdrop from './brand/BrandBackdrop';
import Eyebrow from './brand/Eyebrow';

// The auth surface (sign in / register / forgot / reset), styled to match the
// branchcad.com landing site: the ambient engineering-grid backdrop, the brand
// lockup, a drawing-callout eyebrow, a display-face title and a quiet white panel
// with a hairline border + soft elevation. Colours/fonts read from the live
// --cad-* tokens, so light mode reproduces the landing's drafting-sheet look and
// dark mode degrades cleanly.
export default function AuthCard({
  title,
  subtitle,
  eyebrow,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="relative flex min-h-full items-center justify-center p-6">
      <BrandBackdrop />

      <div className="w-full max-w-sm">
        {/* brand lockup — logo.svg is shared with the landing site (continuity). */}
        <div className="mb-6 flex justify-center">
          <img src="/logo.svg" alt={APP_NAME} className="h-auto w-[min(13rem,52vw)]" />
        </div>

        <div
          className="space-y-5 rounded-xl border border-border bg-card p-7"
          style={{ boxShadow: 'var(--brand-shadow-panel)' }}
        >
          <div className="space-y-2 text-center">
            {eyebrow ? <Eyebrow className="justify-center">{eyebrow}</Eyebrow> : null}
            <h1 className="brand-h2 text-foreground">{title}</h1>
            {subtitle ? <p className="text-sm text-muted-foreground">{subtitle}</p> : null}
          </div>
          {children}
        </div>

        {footer ? (
          <div className="mt-5 text-center text-sm text-muted-foreground">{footer}</div>
        ) : null}
      </div>
    </div>
  );
}
